module.exports = __webpack_public_path__ + "oeuf.png?3cc5d68d689acd43dfb24f29ebda0fd3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oeuf.png
// module id = 183
// module chunks = 0